import { graphqlApiClient } from '../client';
import {
  PREVENTION_QUERY,
  PreventionMetaObjectNode,
  PreventionQueryResponse,
  PreventionQueryVariants,
} from './query';
import { Prevention } from './types';

export async function fetchGraphqlPrevention(typename: string) {
  try {
    const result = await graphqlApiClient<PreventionQueryResponse, PreventionQueryVariants>(
      PREVENTION_QUERY,
      { typename }
    );

    const nodes = result.metaobjects.nodes;

    return parsedPrevention(nodes);
  } catch (error) {
    console.log('error: Meta object data was not found', error);
    return [];
  }
}

/**
 * メタオブジェクトを取得するための関数
 * @param query 任意のGraphQLクエリ
 * @returns メタオブジェクトのデータ
 */
function parsedPrevention(nodes: PreventionMetaObjectNode[]): Prevention[] {
  // データを updateAt で降順ソート
  const sortedNodes = nodes.sort((a, b) => {
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });

  // 最新のノードを取得
  const latestNode = sortedNodes[0];

  if (!latestNode || !latestNode.fields) {
    throw new Error('No fields found in the response');
  }

  const fields = latestNode.fields;

  const preventionList: Prevention[] = [];
  for (let i = 1; i <= fields.length; i++) {
    const image = fields.find((f) => f.key === 'image' + i)?.value;

    if (image) {
      const linkField = fields.find((f) => f.key === 'link' + i);
      const linkValue = linkField?.value
        ? (JSON.parse(linkField.value) as { text: string; url: string | null })
        : { text: '', url: '' };
      preventionList.push({ image, url: linkValue.url ?? '' });
    } else {
      break;
    }
  }

  return preventionList;
}
